import type { JiraChildIssue } from '@shared/types.js';

/** How many of an issue's children are done, for the progress bar. */
export function childProgress(items: Array<Pick<JiraChildIssue, 'status'>>): { done: number; total: number; percent: number } {
  const total = items.length;
  const done = items.filter((i) => i.status.category === 'done').length;
  return { done, total, percent: total ? Math.round((done / total) * 100) : 0 };
}

/** Up to this many children fit beside the issue; a longer list goes under the description. */
export const SIDE_PANEL_MAX_CHILDREN = 6;

export function childPanelPlacement(count: number): 'side' | 'main' {
  return count > SIDE_PANEL_MAX_CHILDREN ? 'main' : 'side';
}
